<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工艺管理</el-breadcrumb-item>
      <el-breadcrumb-item>工艺流程</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加产品类型按钮 -->
      <el-row>
        <el-col>
          <el-button type="success" @click="addDialogVisible = true">新增工艺</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 工艺信息表格 -->
        <el-button
          icon="el-icon-download"
          circle
          @click="getpdfyes"
          class="download"
          type="warning"
          size="medium"
        ></el-button>
        <el-table id="pdfDom" :data="craftMessageList" border stripe class="123">
          <el-table-column type="index"></el-table-column>
          <el-table-column label="工艺编号" prop="TechnologyNO"></el-table-column>
          <el-table-column label="工艺名称" prop="TechnologyName"></el-table-column>
          <el-table-column label="工艺内容" prop="TechnologyContent"></el-table-column>
          <el-table-column label="是否启用" prop="Is_Use"></el-table-column>
          <el-table-column label="备注" prop="Remark"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeType(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="getTypeList.page"
        :page-sizes="[5, 10, 15]"
        :page-size="getTypeList.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 编辑设备的会话框 -->
    <el-dialog title="修改工艺信息" :visible.sync="editDialogVisible" width="40%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <div class="tech01">
          <el-form-item label="工艺编号" prop="TechnologyNO" required>
            <el-input v-model="editForm.TechnologyNO" style="width: 110%" size="medium"></el-input>
          </el-form-item>
          <el-form-item label="工艺名称" prop="TechnologyName" required>
            <el-input v-model="editForm.TechnologyName" style="width: 110%" size="medium"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="工艺内容" prop="TechnologyContent" required>
          <el-input v-model.number="editForm.TechnologyContent" style="width: 84%" size="medium"></el-input>
        </el-form-item>
        <div class="tech01">
          <el-form-item label="是否启用" prop="Is_Use" required>
            <el-select v-model="editForm.Is_Use" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
          <div class="remark">
            <el-form-item label="备注" prop="Remark">
              <el-input v-model.number="editForm.Remark" style="width: 123%" size="medium"></el-input>
            </el-form-item>
          </div>
        </div>
        <div>
          <el-divider></el-divider>
        </div>
        <div>
          <el-form>
            <el-form-item label="添加工序" prop="Process_ID">
              <el-select v-model="addForm1.Process_ID" placeholder="请选择">
                <el-option
                  v-for="item in processMessageList"
                  :key="item.ID"
                  :label="item.ProcessName"
                  :value="item.ID"
                ></el-option>
              </el-select>
              <el-button type="primary" class="btn1" @click="techAndProcess(scope)">确 定</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 工艺工序绑定信息表格 -->
        <el-table id="pdfDom" :data="TechAndProcessList" border stripe class="123">
          <el-table-column type="index"></el-table-column>
          <el-table-column label="工序编号" prop="ProcessNO"></el-table-column>
          <el-table-column label="工序名称" prop="ProcessName"></el-table-column>
          <el-table-column label="工序内容" prop="ProcessContent"></el-table-column>
          <el-table-column label="备注" prop="Remark"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeTechAndProcess(scope)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加工序的对话框 -->
    <el-dialog title="新增工艺" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="工艺编号" prop="TechnologyNO" required>
          <el-input v-model="addForm.TechnologyNO" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工艺名称" prop="TechnologyName" required>
          <el-input v-model="addForm.TechnologyName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="工艺内容" prop="TechnologyContent" required>
          <el-input v-model.number="addForm.TechnologyContent" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="Is_Use" required>
          <el-select v-model="addForm.Is_Use" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model.number="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: 1,
                limit: 5,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_TechnologySet'
            },
            getTypeList1: {
                page: 1,
                limit: 100,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'Mes_TechnologySet'
            },
            // 查询绑定所需
            getTypeList2: {
                page: 1,
                limit: 100,
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                ID: ''
            },
            // 工艺信息列表
            craftMessageList: [],
            // 总数据条数
            total: 0,
            // 控制修改信息对话框的显示与隐藏
            editDialogVisible: false,
            // 控制添加信息对话框的显示与隐藏
            addDialogVisible: false,
            // 编辑用户信息的表单
            editForm: {},
            // 添加用户的表单数据
            addForm: {
                TechnologyNO: '',
                TechnologyName: '',
                TechnologyContent: '',
                Is_Use: '',
                Remark: '',
            },
            // 添加工序绑定的表单数据
            addForm1: {
                Process_ID: ''
            },
            //添加表单的验证规则对象
            addFormRules: {
                Address: [
                    { required: true, message: '请输入正确的IP地址', validator: this.validateIP, trigger: 'blur' }
                ],
                Port: [
                    { type: "number", message: '请输入正确的端口号', trigger: 'blur' }
                ]
            },
            // 修改表单的验证规则对象
            editFormRules: {
                Address: [
                    { required: true, message: '请输入正确的IP地址', validator: this.validateIP, trigger: 'blur' }
                ],
                Port: [
                    { type: "number", message: '请输入正确的端口号', trigger: 'blur' }
                ]
            },
            // 是否启用
            options: [{
                value: 'Y',
                label: '是'
            }, {
                value: 'N',
                label: '否'
            }],
            // 工序表名
            tableName: 'Mes_ProcessSet',
            // 工序信息表
            processMessageList: [],
            // 测试用
            testID: '',
            // 关联表名
            tableName1: 'Mes_Technology_Process',
            // 关联信息表
            TechAndProcessList: []
        }
    },
    created () {
        this.getType()
        this.getType1()
        this.getProcess()
    },
    methods: {
        // 调用接口获取工艺信息
        async getType () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList })
            console.log(res.data)
            for (var i = 0; i < res.data.length; i++) {
                if (res.data[i].Is_Use == 'Y') {
                    res.data[i].Is_Use = '是'
                }
                if (res.data[i].Is_Use == 'N') {
                    res.data[i].Is_Use = '否'
                }
            }
            console.log(res)
            this.craftMessageList = res.data
            // console.log(res.data.length)
        },
        // 调用接口获取工艺信息
        async getType1 () {
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params: this.getTypeList1 })
            console.log(res.data)
            this.total = res.data.length
            // console.log(res.data.length)
        },
        // 调用接口删除工艺
        async removeType (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该设备, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }

            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.post('/WMS/Deletetechnologyset', params)
            console.log(res)
            if (res == -3) {
                return this.$message.error('该工艺已绑定在订单下，无法删除！')
            }
            if (res !== 1) {
                return this.$message.error('系统异常，删除失败！')
            }
            this.$message.success('删除成功！')
            this.getType()
            this.getType1()
        },
        // 展示修改工艺信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams()
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("tableName", this.getTypeList.tableName)
            params.append("appIdentification", this.getTypeList.appIdentification)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            this.editForm = res.data[0]
            this.testID = res.data[0].ID
            this.getTypeList2.ID = res.data[0].ID
            this.getTechAndProcess()
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口新增工艺
        addProduct () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("TechnologyNO", this.addForm.TechnologyNO)
                params.append("TechnologyName", this.addForm.TechnologyName)
                params.append("TechnologyContent", this.addForm.TechnologyContent)
                params.append("Is_Use", this.addForm.Is_Use)
                params.append("Remark", this.addForm.Remark)
                console.log('00' + params)
                const { data: res } = await this.$http.post('/WMS/InsertTechnologySetID', params)
                console.log(res)
                console.log(res.data)
                if (res !== 1) {
                    return this.$message.error('系统异常,新增失败！')
                }
                this.$message.success('添加工艺成功！')
                // 隐藏添加用户的对话框
                this.addDialogVisible = false
                // 重新获取用户列表数据
                this.getType()
                this.getType1()
            })
        },
        // 调用接口编辑工艺
        editProduct () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("TechnologyNO", this.editForm.TechnologyNO)
                params.append("TechnologyName", this.editForm.TechnologyName)
                params.append("TechnologyContent", this.editForm.TechnologyContent)
                params.append("Is_Use", this.editForm.Is_Use)
                params.append("Remark", this.editForm.Remark)
                params.append("ID", this.editForm.ID)
                console.log('123' + params)
                const { data: res } = await this.$http.post('/WMS/updateTechnologySetID', params)
                console.log(res)
                if (res !== 1) {
                    return this.$message.error('更新工艺信息失败！')
                }

                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getType()
                this.getType1()
                // 提示修改成功
                this.$message.success('更新工艺信息成功！')
            })
        },
        // 监听 pagesize 改变的事件
        handleSizeChange (newSize) {
            console.log('111' + newSize)
            this.getTypeList.limit = newSize
            this.getType()
        },
        // 监听 页码值 改变的事件
        handleCurrentChange (newPage) {
            console.log(newPage)
            this.getTypeList.page = newPage
            this.getType()
        },
        getpdfyes () {
            this.getPdf()
        },
        // 调用接口查询工序
        async getProcess () {
            let params = new URLSearchParams()
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("tableName", this.tableName)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("page", this.getTypeList.page)
            params.append("limit", this.getTypeList1.limit)
            const { data: res } = await this.$http.get('/WMS/GeneralQuery', { params })
            console.log(res.data)
            console.log(res)
            this.processMessageList = res.data
        },
        // 调用接口绑定工艺工序
        async techAndProcess (scope) {
            let params = new URLSearchParams()
            if (!this.addForm1.Process_ID) return
            params.append("Technology_ID", this.testID)
            params.append("Process_ID", this.addForm1.Process_ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('123' + params)
            const { data: res } = await this.$http.post('/WMS/InsertTechnologyProcess', params)
            console.log(res)
            this.getTechAndProcess()
        },
        //调用接口查询工艺工序绑定
        async getTechAndProcess () {
            let params = new URLSearchParams()
            params.append("page", this.getTypeList2.page)
            params.append("ID", this.getTypeList2.ID)
            params.append("limit", this.getTypeList2.limit)
            params.append("privateKey", this.getTypeList2.privateKey)
            params.append("appIdentification", this.getTypeList2.appIdentification)
            console.log('123' + params)
            const { data: res } = await this.$http.get('/WMS/TechnologyProcess', { params })
            console.log(res)
            this.TechAndProcessList = res.data
        },
        // 调用接口删除工艺工序关联信息
        async removeTechAndProcess (scope) {
            let params = new URLSearchParams()
            params.append("ID", scope.row.TPID)
            params.append("tableName", this.tableName1)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('123' + params)
            const { data: res } = await this.$http.post('/WMS/GeneralDelete', params)
            console.log(res)
            this.getTechAndProcess()
        }
    }
}
</script>

<style lang="less" scoped>
.download {
  position: absolute;
  left: 94%;
  top: 12%;
  transform: translate(50%, 50%);
}
.tech01 {
  display: flex;
}
.remark {
  position: relative;
  left: -6%;
}
.btn1 {
  margin-left: 1%;
}
</style>

